"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const InappropriateContentError_1 = __importDefault(require("./errors/InappropriateContentError"));
class ChatbotServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async query(query) {
        const url = `${this.url}/api/query`;
        const options = { method: 'POST', body: JSON.stringify(query) };
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400)
            throw new InappropriateContentError_1.default();
        return response.json;
    }
    async generatePrompts(request) {
        const url = `${this.url}/api/generate-prompts`;
        const options = { method: 'POST', body: JSON.stringify(request) };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async search(request) {
        const url = `${this.url}/api/search`;
        const options = { method: 'POST', body: JSON.stringify(request) };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async explain(request) {
        const url = `${this.url}/api/explain`;
        const options = { method: 'POST', body: JSON.stringify(request) };
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400)
            throw new InappropriateContentError_1.default();
        return response.json;
    }
}
exports.default = ChatbotServiceClient;
//# sourceMappingURL=ChatbotServiceClient.js.map